export default __webpack_public_path__ + "static/media/homeScene_7.f795272c.png";